import React from "react";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import { useParams } from "react-router-dom";
import config from "@frameworks/salesjourney/config/domain";
var CasDownload = function () {
    var requestid = useParams().requestid;
    console.log("requestid", config.casAdvisoryUrl +
        "?vendorCode=".concat(process.env.PICK_RIGHT_VENDOR_CODE, "&token=").concat(atob(requestid)) +
        "&requestId=".concat(atob(requestid)));
    return (React.createElement(GridContainer, { parentClass: "advisory-dashboard-primary-conatiner" },
        React.createElement("embed", { src: config.casAdvisoryUrl +
                "?vendorCode=".concat(process.env.PICK_RIGHT_VENDOR_CODE, "&token=").concat(atob(requestid)) +
                "&requestId=".concat(atob(requestid)), type: "text/html", className: "embeded-subScreen" })));
};
export default CasDownload;
